import { QuestionScore, StudentScore } from '~teacher/models/activities';

interface FindStudentScoreArgs {
  studentId: number;
  questionId: number;
  questionScores: Record<string, QuestionScore>;
}

export const findStudentScore = ({
  studentId,
  questionId,
  questionScores,
}: FindStudentScoreArgs): StudentScore => {
  if (!studentId || !questionId || !questionScores) return null;
  return questionScores[questionId]?.studentScores[studentId] ?? null;
};
